import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerProfileDetailsRequest extends BaseUpdateRequest {
    // Title lives with the name fields — person attribute, not payroll data.
    title = 0;
    firstName = '';
    lastName = '';
    summary = '';
}